export enum ProjectTabType {
	AVAILABLE = 'AVAILABLE',
	HIDDEN = 'HIDDEN'
}